export const PARENT_WINDOW_NAME = 'cis-parent';

/**
 * DOC_TYPE配列の描画インデックスから実際のDOC_TYPE枝番を取得する
 * 欠番があっても正しい枝番（例: '4_6' → 6）を返す
 * @param docTypeArray docRelatedCustoms や docOutsideCustoms 等の DOC_TYPE 配列
 * @param index テーブルの描画インデックス（0始まり）
 * @returns DOC_TYPE の枝番（数値）
 */
export const getDocTypeNum = (docTypeArray: string[], index: number): number =>
  parseInt(docTypeArray[index]?.split('_')[1] ?? String(index + 1));

/**
 * DOC_TYPE文字列から描画順に対応するフォームフィールド番号を取得する
 * 欠番があっても描画インデックスを基準に正しい番号（REMARKS_DR_N のN）を返す
 * @param docTypeArray docRelatedCustoms 等の DOC_TYPE 配列
 * @param docType 対象の DOC_TYPE 文字列（例: '4_6'）
 * @returns フォームフィールド番号（描画インデックス+1）
 */
export const getDocTypeRenderNum = (docTypeArray: string[], docType: string): number => {
  const renderIndex = docTypeArray.findIndex((dt: string) => dt === docType);
  return renderIndex >= 0 ? renderIndex + 1 : parseInt(docType.split('_')[1] || '1');
};

/**
 * 対象の文字列のインデックスを指定して、文字列の間に文字を追加する
 * @param param0
 * @returns
 */
export const addString = ({ string, index, stringToAdd }: { string: string; index: number; stringToAdd: string }) => {
  if (!string) {
    return '';
  }
  return string.substring(0, index) + stringToAdd + string.substring(index, string.length);
};

/**
 * 文字列のバイト数をカウントして、上限バイト数を超えていないかチェックする
 * @param str 対象文字列
 * @param byteLimit 上限byte数
 * @returns 上限を超えない場合、trueを返却する
 */
export const validateByteLength = (str: string, byteLimit: number) => {
  // return encodeURI(str).replace(/%[0-9A-F]/g, '').length <= byteLimit;
  const encoder = new TextEncoder();
  const encodedStr = encoder.encode(str);
  return encodedStr.length <= byteLimit;
};

/**
 * ファイル名を指定したbyte数で文字列を分割する
 * ※指定したbyte数が全角文字であった場合、直前の文字までを分割する
 * @param inputStr 対象文字列
 * @param byteLimit 上限byte数
 * @returns 上限byte数までの文字列を返却する
 */
export const substringByByte = (inputStr: string, byteLimit: number) => {
  const encoder = new TextEncoder();
  let currentByte = 0;

  return Array.from(inputStr)
    .filter((char) => {
      const charByte = encoder.encode(char).length;
      if (currentByte + charByte > byteLimit) return false;
      currentByte += charByte;
      return true;
    })
    .join('');
};
